import type { DBRecord } from '../services/PreferencesDB.ts';
import type { Task } from './Task.ts';

export class Score implements DBRecord {
  id: string = crypto.randomUUID();
  createdAt: number = Date.now();
  lastModified: number = Date.now();
  task: string;
  icon: string;
  value: number = 1;
  photoId?: string; // Directus file ID for the uploaded photo
  constructor(task: Task) {
    this.task = task.id;
    this.icon = task.icon;
    this.value = task.score;
  }

  static isToday(score: Score): boolean {
    const startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);
    const startTime = startOfDay.getTime();
    return score.createdAt >= startTime;
  }
}
